export enum AUTH_METHODS {
  EMAIL = "email",
  APP = "app"
}
